module.exports = __webpack_public_path__ + "static/media/8OLA31.ae804bf4.jpg";